<section class="provider-profile">
  <div class="provider-header-with-bio">
    <div class="provider-header">
      <br *ngIf="noProfilePhoto">
      <div *ngIf="!noProfilePhoto" class="image-container">
        <img 
          src="{{ providerShareableProfile.profile_photo_url }}" 
          alt="{{ providerShareableProfile.display_name }} profile image" 
          class="provider-image"
          fetchpriority="high"
        >
      </div>
  
      <div class="provider-header-details">
        <div class="names-and-pronouns-container">
          <h1 class="provider-name" data-test="provider-display-name">{{ providerShareableProfile.display_name }}</h1>
          <span 
            class="provider-pronouns" 
            *ngIf="providerShareableProfile?.pronouns?.length > 0 && !showRedesignFf"
            data-test="provider-pronouns"
          >
            ({{ providerShareableProfile.pronouns }})
          </span>
        </div>
        <p *ngIf="showRedesignFf" class="provider-credentials">
          {{ providerType }} • <span class="provider-credential-abbreviations"> {{ certificationAbbreviations }} </span>
          <span 
            class="provider-pronouns" 
            *ngIf="providerShareableProfile?.pronouns?.length > 0"
            data-test="provider-pronouns"
          >
            ({{ providerShareableProfile.pronouns }})
          </span>
        </p>
        <div *ngIf="showRedesignFf" class="provider-licensed-states">
          {{ credentialStatesFormatted | stringArrayToCommaList }}
        </div>
        <ng-container *ngIf="!showRedesignFf">
          <p class="provider-credentials" *ngFor="let certification of providerShareableProfile.certifications">
            {{ certification.name }}
          </p>
        </ng-container>
        
        <div class="type-and-insurance-container">
          <div
            *ngIf="showRedesignFf; else oldSessionsInsurancesTemplate"
            class="provider-pills"
          >
            <provider-pills
              [providerAcceptedInsuranceIds]="providerShareableProfile.provider_network_company_ids"
              [providerInsurances]="providerShareableProfile.insurances"
              [providerTopSpecialtiesIds]="topSpecialtiesIds"
              [providerSpecialties]="providerShareableProfile.specialties"
              [providerSessionTypesOffered]="providerShareableProfile.session_types_offered"
              [selectedInsuranceName]="queryParamMap.get('insuranceName')"
              [selectedInsurancePncId]="queryParamMap.get('pncId')"
              [selectedSpecialties]="queryParamSpecialties"
            ></provider-pills>
          </div>
  
          <ng-template #oldSessionsInsurancesTemplate>
            <p class="provider-session-type">
              <iris-icon
                name="location_on"
                [size]="iconSizes.MD"
                colorToken="$color-dec-kelly-100"
              >
              </iris-icon>
              {{ sessionTypeString }}
            </p>
            <p *ngIf="providerShareableProfile?.credentialed_states?.length > 0" class="provider-state">
              Practicing in {{ credentialStatesFormatted | stringArrayToCommaList }}
            </p>
            <div *ngIf="providerShareableProfile.insurances.length > 0; else selfPay">
              <p class="provider-header-insurance-title">
                <iris-icon
                  name="verified_user"
                  [size]="iconSizes.MD"
                  colorToken="$color-dec-kelly-100"
                >
                </iris-icon>
                Insurance
              </p>
              <p class="provider-header-insurances-accepted">
                {{ providerInsurances | slice:0:maxLengthOfInsuranceListString }}{{providerInsurances.length > maxLengthOfInsuranceListString ? '...' : ''}}
              </p>
            </div>
            <button 
              class="show-insurance-list-button" 
              *ngIf="providerInsurances.length > maxLengthOfInsuranceListString" 
              (click)="scrollToElement('insurance-and-licensure-section')"
              data-test="show-insurance-list-button"
              tabindex="0"
            >
              See all below
            </button>
          </ng-template>
        </div>
  
        <div
          *ngIf="providerShareableProfile.psl_feature_flag && !showRedesignFf"
          class="scheduling-container"
          [ngClass]="{ 'hide-margin': (!showAccepting) }"
          data-test="scheduling-container"
        >
          <ng-container *ngIf="showAccepting">
            <button
              *ngIf="useCheckoutFormFf; else linkToFlow"
              (click)="onRequestASessionClick(false)"
              class="request-session-button"
              data-test="request-session-button"
            >
              Request a session
            </button>
            <ng-template #linkToFlow>
              <a
                [routerLink]="['/match', paramsShareCode, paramsName]"
                [queryParams]="requestSessionQueryParams"
                class="request-session-button"
                data-test="request-session-button"
                tabindex="0"
                (click)="onRequestASessionClick(true)"
              >
                Request a session
              </a>
            </ng-template>
          </ng-container>
  
          <div 
            class="not-accepting-clients-cta-desktop"
            *ngIf="providerShareableProfile.psl_feature_flag && !showAccepting" 
            data-test="not-accepting-clients"
          >
            <non-accepting-match-options data-test="non-accepting-match-options"></non-accepting-match-options>
          </div>
        </div>
      </div>
    </div>

    <div class="bio-specialty-details" *ngIf="showRedesignFf">
      <div class="mini-bio-container">
        <iris-icon
          name="quote"
          colorToken="$color-dec-indigo-100"
        />
        <div class="mini-bio">
          {{ providerShareableProfile.mini_bio }} <span class="name-signoff"> – {{ providerShareableProfile.display_first_name }} </span>
        </div>
      </div>
    
      <div class="specializes-in" *ngIf="topSpecialties.length > 0;">
        <h3>
          <iris-icon
            name="stars"
            colorToken="$color-dec-kelly-100"
          />
          Specializes in
        </h3>
        <div class="specialties-list">
          <div
            *ngFor="let specialty of topSpecialties, let i = index"
          >
            <span [ngClass]="{'highlight': specialty.isQueryParam}">{{specialty.name}}</span> 
            <span>{{i < topSpecialties.length - 1 ? ',  ' : ''}}</span>
            <span>{{i == topSpecialties.length - 2 ? 'and' : ''}}</span>
          </div>
        </div>
        <button 
          class="show-specialties-list-button" 
          (click)="scrollToElement('specialties-section')"
          tabindex="0"
        >
          Show more
        </button>
      </div>
    </div>
  </div>
  
</section>

<div
  *ngIf="providerShareableProfile.psl_feature_flag && !showAccepting" 
  class="not-accepting-clients-cta-mobile"
>
  <non-accepting-match-options></non-accepting-match-options>
</div>

<ng-template #selfPay>
  <p class="provider-header-insurance-title">
    <iris-icon
      name="verified_user"
      [size]="iconSizes.MD"
      colorToken="$color-dec-kelly-100"
    >
    </iris-icon>
    Accepts self-pay only
  </p>
  <br/>
</ng-template>
